var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4338_45200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00583 2.65435C8.85483 -0.265586 12.4448 0.0586531 13.9135 2.5555C14.6677 2.59024 15.3909 2.52403 16.0666 2.67313C18.1142 3.12518 19.3642 5.07796 18.9825 7.13599C18.9201 7.47282 18.99 7.65383 19.2806 7.86033C21.5911 9.50209 21.5677 12.6827 19.2436 14.3373C19.0253 14.4926 18.9126 14.6252 18.9597 14.9255C19.4396 17.9857 17.0418 20.1989 14.0162 19.5028C11.7581 22.306 9.00299 22.3125 7.00604 19.5063C5.49324 19.8013 4.10845 19.5934 2.99544 18.4005C2.10981 17.4513 1.81475 16.3208 2.01296 15.0633C2.06931 14.7059 2.00772 14.5141 1.70184 14.2959C-0.580952 12.6673 -0.562589 9.49034 1.72912 7.8468C1.9605 7.6809 2.0904 7.5469 2.03668 7.22172C1.54266 4.23284 3.96595 1.97397 6.90415 2.66673C6.93542 2.67418 6.97183 2.65928 7.00583 2.65435ZM9.16637 12.3272C8.55368 11.6984 7.98809 11.1062 7.40908 10.5276C6.89638 10.0151 6.31464 9.96463 5.88379 10.3743C5.44108 10.7953 5.48631 11.401 6.01632 11.9379C6.76522 12.6964 7.52146 13.4479 8.27687 14.2001C8.9479 14.8681 9.43112 14.8672 10.1055 14.1938C11.7009 12.6009 13.2946 11.0065 14.8875 9.41122C15.0107 9.28782 15.1384 9.16432 15.2372 9.02224C15.5139 8.62465 15.4663 8.10745 15.1375 7.77292C14.8152 7.4448 14.2872 7.38279 13.8919 7.64701C13.7342 7.75246 13.5989 7.89454 13.4633 8.0299C12.0542 9.43672 10.6472 10.8455 9.16637 12.3272Z",
    fill: "#1F3151"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17003 12.3271C10.6507 10.8456 12.0579 9.43677 13.467 8.02985C13.6026 7.89449 13.7378 7.75241 13.8955 7.64695C14.2908 7.38263 14.8188 7.44475 15.1412 7.77287C15.4698 8.10739 15.5175 8.6246 15.2409 9.02219C15.142 9.16426 15.0143 9.28777 14.8911 9.41117C13.2981 11.0064 11.7045 12.6009 10.1092 14.1938C9.43466 14.8671 8.95145 14.868 8.28052 14.2C7.52512 13.4479 6.76887 12.6965 6.01997 11.9378C5.48996 11.401 5.44484 10.7951 5.88744 10.3742C6.31829 9.96458 6.90004 10.0151 7.41273 10.5275C7.99175 11.1061 8.55733 11.6983 9.17003 12.3271Z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4338_45200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21.0355,
    fill: "white",
    transform: "translate(0 0.572021)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructions);
export default __webpack_public_path__ + "static/media/instructions.c67fec930811551da025ba2470eea001.svg";
export { ForwardRef as ReactComponent };